import * as React from 'react';
import classNames from 'classnames';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
const styles = (theme) => createStyles({
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
    },
    title: {
        fontSize: theme.font.size.big,
        fontWeight: theme.font.weight.bold,
        padding: '20px 0px 0px 20px',
    },
    root: {
        fontSize: theme.font.size.medium,
        color: theme.color.font.dark,
        padding: '25px 25px 0 20px',
        minHeight: '30px',
        minWidth: '500px',
    },
});
const Modal = (props) => {
    const { classes, className: classNameProp, open, title, children, closeIcon, actions, testId = 'Modal', ...other } = props;
    const actionsEl = actions ? React.createElement(DialogActions, null, actions) : React.createElement("div", null);
    const className = classNames(classes.root, classNameProp);
    const dialogContent = children && React.createElement(DialogContent, { className: className }, children);
    return (React.createElement(Dialog, { open: open, "data-testid": testId, ...other },
        React.createElement("img", { src: closeIcon, className: classes.closeIcon, alt: "Close" }),
        React.createElement(DialogTitle, { "data-testid": `${testId}-title`, disableTypography: true, className: classes.title }, title),
        dialogContent,
        actionsEl));
};
const ComposedModal = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    open: true,
    children: null,
    closeIcon: '',
    title: '',
}))(Modal);
ComposedModal.displayName = 'Modal';
export default ComposedModal;
//# sourceMappingURL=Modal.js.map